// extracted by mini-css-extract-plugin
module.exports = {"root":"PricingCards_root___K71W","card":"PricingCards_card__OG1Or"};